import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronUp } from 'lucide-react';
const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          initial={{ opacity: 0, scale: 0, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0, y: 20 }}
          whileHover={{ 
            scale: 1.05, 
            y: -3,
            transition: { duration: 0.2 }
          }}
          whileTap={{ scale: 0.95 }}
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 z-50 group"
          transition={{
            type: "spring",
            stiffness: 400,
            damping: 17
          }}
        >
          {/* Enhanced Glow Effect */}
          <div className="absolute inset-0 bg-acid-green from-acid-green via-acid-green to-acid-green rounded-full blur-2xl opacity-70 group-hover:opacity-90 transition-all duration-500"></div>
          
          {/* Main Button - Glassmorphism Design */}
          <div className="relative bg-white/10 backdrop-blur-xl border border-white/30 rounded-full p-4 shadow-2xl hover:shadow-acid-green/25 transition-all duration-300">
            <motion.div
              animate={{ y: [0, -1, 0] }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut"
              }}
              className="w-6 h-6 bg-acid-green from-acid-green to-acid-green rounded-full flex items-center justify-center"
            >
              <ChevronUp className="w-4 h-4 text-white" />
            </motion.div>
          </div>
          
          {/* Floating Particles */}
          <motion.div
            className="absolute -top-1 -left-1 w-2 h-2 bg-acid-green rounded-full"
            animate={{ 
              y: [0, -8, 0],
              opacity: [0.5, 1, 0.5]
            }}
            transition={{ 
              duration: 3, 
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
          <motion.div
            className="absolute -bottom-1 -right-1 w-1.5 h-1.5 bg-vivid-orange rounded-full"
            animate={{ 
              y: [0, 8, 0],
              opacity: [0.5, 1, 0.5]
            }}
            transition={{ 
              duration: 4, 
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
          
          {/* Modern Tooltip */}
          <motion.div
            initial={{ opacity: 0, x: 15, scale: 0.9 }}
            whileHover={{ opacity: 1, x: 0, scale: 1 }}
            className="absolute right-full mr-4 top-1/2 transform -translate-y-1/2 bg-white/10 backdrop-blur-xl border border-white/20 rounded-xl px-3 py-2 whitespace-nowrap shadow-2xl"
          >
            <span className="text-white text-sm font-medium">Retour en haut</span>
            <div className="absolute left-full top-1/2 transform -translate-y-1/2 w-0 h-0 border-l-4 border-l-white/10 border-t-4 border-t-transparent border-b-4 border-b-transparent"></div>
          </motion.div>
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default ScrollToTopButton;

